import React from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Link from '../link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TableOfContents = ({
  sections,
  title
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Heading, {
    type: "small",
    children: title
  }), /*#__PURE__*/_jsx("ul", {
    className: classNames(style.list, style.evolved),
    children: sections.map(section => /*#__PURE__*/_jsx("li", {
      className: style.listItem,
      children: /*#__PURE__*/_jsx(Link, {
        title: section.title,
        href: "#".concat(section.slug),
        target: "_self",
        children: section.title
      })
    }, section.slug))
  })]
});

TableOfContents.defaultProps = {
  title: 'Table of Contents'
};
export default TableOfContents;